import { Component, Input } from '@angular/core';
import { Activity } from '@shared/models/activity';
import { ActivityTypeObject } from '@shared/constants/activity-types';

@Component({
  selector: 'app-last-activity-preview',
  templateUrl: './last-activity-preview.component.html',
  standalone: false,
})
export class LastActivityPreviewComponent {
  @Input({ required: true }) activity: Activity;
  @Input() activityType?: ActivityTypeObject;
}
